<template>
  <div>
    <vs-card>
      <div id="draggable-services" class="flex flex-wrap">
        <div class="loading"></div>
        <div class="w-full md:w-2/5 p-3">
          <div class="d-flex align-items-center justify-content-between mb-2" slot="header">
            <h5>اعضای کارگروه</h5>
            <div class="pr-3">
              <vs-button class="font-1" size="small" @click="newMemberIsVisible=true"> افزودن عضو +</vs-button>
            </div>
          </div>
          <div style="height: calc(100vh - 300px);overflow-y: scroll">
            <draggable
              :id="0"
              :value="members"
              @end="serviceChanged"
              :sort="false"
              :options="options"
              group="people"
              class="pr-4 cursor-move">
              <member-card :service-id="0" v-for="listItem in members"
                           :key="listItem.id" :id="listItem.id"
                           :user="listItem">
              </member-card>
            </draggable>
          </div>
        </div>
        <div class="w-full md:w-3/5 p-3">
          <div class="d-flex align-items-center justify-content-between mb-4" slot="header">
            <h5>سرویس ها</h5>
            <div>
              <vs-button class="font-1" size="small" @click="newServiceVisible=true"> افزودن سرویس +</vs-button>
              <vs-button :disabled="members.length===0" color="success" class="font-1 ml-2" size="small"
                         @click="startAutoRouting">مسیربندی خودکار
              </vs-button>
            </div>
          </div>
          <div><span>وضعیت مسیربندی خودکار: </span> {{autoRoutingStatus}}</div>
          <div style="height: calc(100vh - 300px);overflow-y: scroll">
            <div class="service-container mr-1" v-for="service in services">
              <div class="service-info d-flex align-items-center justify-content-between">
                <input @keyup.enter="updateService($event,service.id)"
                       @change="updateService($event,service.id)"
                       v-if="editingServiceId===service.id" type="text"
                       :value="service.name">
                <b v-else>{{service.name}}</b>
                <div>

                  <feather-icon class="cursor-pointer mr-2" @click="sendMessageToService(service)" icon="MailIcon"
                                svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
                  <feather-icon class="cursor-pointer mr-2" @click="showLocations(service.id)" icon="MapPinIcon"
                                svgClasses="w-5 h-5 hover:text-warning stroke-current"/>
                  <feather-icon title="پرینت" class="cursor-pointer mr-2" @click="showService(service)" icon="FileIcon"
                                svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
                  <feather-icon class="cursor-pointer mr-2" @click="toggleEditService(service.id)" icon="EditIcon"
                                svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
                  <feather-icon class="cursor-pointer mr-2" @click="deleteService(service.id)" icon="TrashIcon"
                                svgClasses="w-5 h-5 hover:text-danger stroke-current"/>

                </div>
              </div>

              <div class="driver-item d-flex justify-content-between">
                <div>
                  <div v-if="service.driver" class="d-flex align-items-center">
                    <img height="40" width="40" class="round mr-3 img-fluid"
                         :src="service.driver.imagePath || require('@/assets/images/avatar-car.png')">
                    <div class="mr-2">
                      <div><b>{{service.driver.firstName +' '+ service.driver.lastName}}</b></div>
                      <span class="text-primary">{{ service.driver.cellPhoneNumber}}</span>
                    </div>
                  </div>
                  <div style="height: 40px" class="d-flex align-items-center" v-else>
                    <span>بدون راننده</span>
                  </div>
                </div>
                <vs-button style="height: 30px" class="font-1" size="small" color="warning"
                           @click="showDrivers(service.id)">انتخاب راننده
                </vs-button>
              </div>
              <draggable
                style="min-height: 60px"
                :id="service.id" :value="service.serviceMember"
                @end="serviceChanged" :sort="false" :options="options"
                group="people" class="p-2 cursor-move d-flex flex-wrap">
                <member-card :service-id="service.id" v-for="listItem in service.serviceMember" :key="listItem.id"
                             :id="listItem.id"
                             :user="listItem"></member-card>

                <div v-if="!service.serviceMember.length" class="text-center">بدون دانش آموز</div>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </vs-card>

    <vs-card class="p-1">
      <div style="height: 400px" id="main-map"></div>
      <div class="mt-5" v-if="serviceTotalDistance">
        <h4> مجموع مسافت سرویس : {{serviceTotalDistance}} متر</h4>
      </div>
    </vs-card>

    <task-add-member :isSidebarActive="newMemberIsVisible" @closeSidebar="newMemberIsVisible=false"></task-add-member>


    <vs-popup class="holamundo" title="اختصاص راننده" :active.sync="assignDriverIsVisible">
      <vs-row style="min-height: 60vh" vs-align="start" class="mt-5">
        <vs-col vs-w="12">
          <v-select placeholder="انتخاب راننده" @input="assignDriver" v-model="selectedDriver" :options="drivers"
                    dir="rtl"/>
        </vs-col>
      </vs-row>

    </vs-popup>


    <vs-popup class="holamundo" title="افزودن سرویس" :active.sync="newServiceVisible">
      <vs-row vs-align="start" class="mt-5">
        <vs-col vs-w="12">
          <vs-input v-model="newServiceName" label-placeholder=" نام سرویس " style="width: 100%"></vs-input>
        </vs-col>
        <vs-button :disabled="!newServiceName" @click="createService" class="mt-3">ذخیره</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup title="ارسال پیام به اعضای سرویس" class="send-message" :active.sync="sendMessageVisible">
      <send-message-form @sent="sendMessageVisible=false"></send-message-form>
    </vs-popup>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import MemberCard from "./MemberCard";
  import DriverCard from "./DriverCard";
  import TaskAddMember from "./TaskAddMember";
  import ServiceAssignDriver from "./ServiceAssignDriver";
  import vSelect from "vue-select";
  import SendMessageForm from "../../messages/components/SendMessageForm";
  import 'polyline-encoded';

  export default {
    name: 'TaskServices',
    components: {
      SendMessageForm,
      'v-select': vSelect,
      ServiceAssignDriver,
      TaskAddMember,
      DriverCard,
      MemberCard,
      draggable,
    },
    mounted() {
      this.$store.dispatch('fetchDrivers')
      this.$store.dispatch('getTaskAutoRoutingStatus', {taskId: this.$route.params.id}).then(status => {
        this.autoRoutingStatus = this.displayAutoRoutingStatus(status)
      })

      this.pageMap = L.map('main-map', {fullscreenControl: true})
        .setView([35.6892, 51.3890], 11);

      L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')
        .addTo(this.pageMap);

    },
    data() {
      return {
        options: {
          disabled: false,
        },
        newServiceName: '',
        newServiceVisible: false,
        editingServiceId: 0,
        newMemberIsVisible: false,
        //assign driver
        assigningDriverServiceId: 0,
        assignDriverIsVisible: false,
        selectedDriver: '',

        serviceMembersLayer: '',
        pageMap: '',
        autoRoutingStatus: '',
        sendMessageVisible: false,
        serviceRouteLayer : '',
        serviceTotalDistance: 0
      }
    },
    computed: {
      services: {
        get() {
          return this.$store.getters.taskInfoServices;
        },
        set(val) {
          console.log('setter : ')
        }
      },
      members() {
        let studentIds = this.$store.state.taskInfo.usersWithNoService
        if (studentIds)
          return this.$store.state.task.members.filter(i => {
            return studentIds.includes(i.id)
          });
        else
          return []
      },
      drivers() {
        return this.$store.state.drivers.map(i => {
          return {
            label: i.firstName + ' ' + i.lastName,
            value: i.id
          }
        })
      }
    },
    methods: {
      serviceChanged(ev) {
        if (ev.from.id === ev.to.id)
          return

        this.$vs.loading({
          container: '#draggable-services',
          scale: 0.6
        })

        this.options.disabled = true

        if (!Number(ev.from.id)) {
          let user = this.members.find(i => i.id === Number(ev.item.id))
          this.$store.dispatch('addServiceMember', {
            serviceId: Number(ev.to.id),
            userId: user.id,
            user: user,
            newIndex: ev.newIndex
          })
            .finally(() => {
              this.options.disabled = false
              this.$vs.loading.close('#draggable-services > .con-vs-loading')
            })
        } else if (!Number(ev.to.id)) {
          let fromService = this.services.find(i => i.id === Number(ev.from.id))
          let user = fromService.serviceMember.find(i => i.id === Number(ev.item.id))
          this.$store.dispatch('deleteServiceMember', {
            serviceId: fromService.id,
            userId: user.id,
          }).finally(() => {
            this.options.disabled = false
            this.$vs.loading.close('#draggable-services > .con-vs-loading')
          })
        } else {
          let fromService = this.services.find(i => i.id === Number(ev.from.id))
          let user = fromService.serviceMember.find(i => i.id === Number(ev.item.id))
          this.$store.dispatch('deleteServiceMember', {
            serviceId: fromService.id,
            userId: user.id,
          })
            .then(res => {
              if (res) {
                this.$store.dispatch('addServiceMember', {
                  serviceId: Number(ev.to.id),
                  userId: user.id,
                  user: user,
                  newIndex: ev.newIndex
                })
              }
            })
            .finally(() => {
              this.options.disabled = false
              this.$vs.loading.close('#draggable-services > .con-vs-loading')
            })
        }
      },
      toggleEditService(id) {
        this.editingServiceId = this.editingServiceId === id ? 0 : id
      },
      createService() {
        this.$store.dispatch('createService', {
          name: this.newServiceName,
          taskId: Number(this.$store.state.taskInfo.id)
        }).then(() => {
          this.newServiceVisible = false
        })
      },
      updateService(ev, serviceId) {
        if (ev.target.value) {
          this.$store.dispatch('updateService', {
            serviceId: serviceId,
            name: ev.target.value,
          }).then(() => {
            this.editingServiceId = 0
          })
        }
      },
      deleteService(serviceId) {
        if (confirm('آیا اطمینان دارید؟')) {
          this.$store.dispatch('deleteService', {
            serviceId: serviceId
          })
        }
      },
      startAutoRouting() {
        this.$store.dispatch('startAutoRouting', {
          taskId: Number(this.$store.state.task.id)
        }).then(res => {
          if (res) {
            alert('درخواست با موفقیت انجام شد')
            this.$store.dispatch('getTaskAutoRoutingStatus', {taskId: this.$route.params.id}).then(status => {
              this.autoRoutingStatus = this.displayAutoRoutingStatus(status)
            })
          }
        })
      },
      showDrivers(serviceId) {
        this.assignDriverIsVisible = true
        this.assigningDriverServiceId = serviceId
      },
      assignDriver(item) {
        this.$vs.loading({
          container: '#draggable-services',
          scale: 0.6
        })
        this.$store.dispatch('assignServiceDriver', {
          serviceId: this.assigningDriverServiceId,
          userId: item.value
        }).then(res => {
          if (res) {
            this.selectedDriver = '';
            this.assignDriverIsVisible = false
          }
        }).finally(() => {
          this.$vs.loading.close('#draggable-services > .con-vs-loading')
        })
      },
      showLocations(serviceId) {
        if (this.serviceMembersLayer)
          this.pageMap.removeLayer(this.serviceMembersLayer)

        let service = this.$store.state.taskInfo.services.find(i => i.id == serviceId)
        let locations = service.serviceMember.map(i => {
          return {
            "type": "Feature",
            "properties": {
              name: i.firstName + ' ' + i.lastName,
              role: 'student'
            },
            "geometry": {
              "type": "Point",
              "coordinates": [i.taskLocationLatLong.longitude, i.taskLocationLatLong.latitude]
            }
          }
        });

        if (service.driver) {
          locations.push({
            "type": "Feature",
            "properties": {
              name: service.driver.firstName + ' ' + service.driver.lastName,
              role: 'driver'
            },
            "geometry": {
              "type": "Point",
              "coordinates": [service.driver.homeLocationLatLong.longitude, service.driver.homeLocationLatLong.latitude]
            }
          })
        }
        this.serviceMembersLayer = L.geoJson(locations, {
          onEachFeature: function (feature, layer) {
            layer.bindPopup(`<div class="popup-speed">
            <div>
              <div style="direction: ltr">  ${feature.properties.name}</div>
            </div>
            </div>`);
          },
          pointToLayer(feature, latlng) {
            if (feature.properties.role === 'driver')

              return L.marker(latlng, {
                icon: new L.Icon({
                  iconUrl: require('../../../assets/images/carpin.png'),
                  iconRetinaUrl: require('../../../assets/images/carpin.png'),
                  iconSize: [60, 60],
                  iconAnchor: [12, 41],
                  popupAnchor: [1, -34],
                })
              })
            else
              return L.circleMarker(latlng, {
                radius: 10,
                fillColor: '#ff4081',
                color: "#fff",
                weight: 1,
                opacity: 1,
                fillOpacity: 1
              });

          }
        }).addTo(this.pageMap);
        this.pageMap.fitBounds(this.serviceMembersLayer.getBounds());

        if (this.serviceRouteLayer)
          this.pageMap.removeLayer(this.serviceRouteLayer)

        if (service.polyLine) {
          this.serviceRouteLayer = L.Polyline.fromEncoded(service.polyLine,
            {
              weight: 3,
              color: '#281889'
            }).addTo(this.pageMap);
          this.pageMap.fitBounds(this.serviceRouteLayer.getBounds());
        }

        if (service.totalCost) {
          this.serviceTotalDistance = service.totalCost
        }

        window.scrollBy(0, 1000)
      },
      displayAutoRoutingStatus(status) {
        switch (status) {
          case 'FINISHED':
            return 'درخواست فعالی وجود ندارد'
          case 'STARTED':
            return 'مسیربندی آغاز شده است'
          case 'PENDING':
            return 'منابع تخصیص داده شده'
          case 'COSTSEXTRACTED':
            return 'هزینه‌ها محاسبه شده است'
          case 'NOTFOUND':
            return 'مسیربندی کارگروه قبلا درخواست نشده است'
          case 'REQUESTED':
            return 'درخواست ارسال شده'
          default:
            return ''
        }
      },
      sendMessageToService(service) {
        let users = []
        service.serviceMember.forEach(i => {
          users.push(i)
        })
        if (service.driver)
          users.push(service.driver)

        this.$store.commit('USERS_WHO_NEED_MSG_CHANGED', {
          action: 'update',
          users: users
        })
        this.sendMessageVisible = true
      },
      showService(service){
        this.$store.commit('SET_STATE',{services:[service]})
        this.$router.push('/services')
      }
    },
    props: {
      data: [Array]
    }
  }
</script>

<style scoped>
  .service-container {
    border-radius: 5px;
    background-color: #bbffe5;
    margin-bottom: 10px;
    border: 1px solid #f7f7f7;
    color: #212121;
  }

  .service-info {
    padding: 8px 10px;
    background-color: #0f163a;
    color: #fff;
    border-radius: 5px 5px 0 0;
  }

  .driver-item {
    padding: 5px 10px;
    background-color: #d2d2d2;
  }
</style>

